import commerce from './pcCommerce'
const cacheCodec = require('./browserStorageCodec')

const CART_KEY = '__ec_web_storefront_checkout_items_v2__'
const LEGACY_CART_KEY = 'pc_mall_cart_items'

export function getCartItems() {
  try {
    let items = cacheCodec.readJson(localStorage, CART_KEY)
    if (!items) {
      const raw = localStorage.getItem(LEGACY_CART_KEY)
      items = raw ? JSON.parse(raw) : []
      if (Array.isArray(items) && items.length) {
        saveCartItems(items)
      }
      localStorage.removeItem(LEGACY_CART_KEY)
    }
    return Array.isArray(items) ? items : []
  } catch (e) {
    return []
  }
}

export function saveCartItems(items) {
  cacheCodec.writeJson(localStorage, CART_KEY, Array.isArray(items) ? items : [])
  localStorage.removeItem(LEGACY_CART_KEY)
}

export function addCartItem(product, quantity = 1) {
  const items = commerce.mergeCartItem(getCartItems(), product, quantity)
  saveCartItems(items)
  return items
}

// “直接购买”只勾选当前商品，保留购物车中其他商品但不带入本次结算。
export function prepareBuyNowItem(product, quantity = 1) {
  const uncheckedItems = getCartItems().map(item => ({ ...item, checked: false }))
  const items = commerce.mergeCartItem(uncheckedItems, product, quantity).map(item => ({
    ...item,
    checked: String(item.id) === String(product.id || product.productId),
    ...(String(item.id) === String(product.id || product.productId) ? { quantity: Number(quantity) } : {})
  }))
  saveCartItems(items)
  return items
}

export function updateCartItem(id, patch) {
  const items = getCartItems().map(item => {
    if (String(item.id) !== String(id)) return item
    return {
      ...item,
      ...patch
    }
  })
  saveCartItems(items)
  return items
}

export function removeCartItem(id) {
  const items = getCartItems().filter(item => String(item.id) !== String(id))
  saveCartItems(items)
  return items
}

export function getCartSummary(items = getCartItems()) {
  const checkedItems = items.filter(item => item.checked)
  const totalQuantity = items.reduce((sum, item) => sum + Number(item.quantity || 0), 0)
  const totalAmount = checkedItems.reduce((sum, item) => {
    return sum + commerce.getTierPrice(item, item.quantity) * Number(item.quantity || 0)
  }, 0)
  return {
    totalQuantity,
    checkedCount: checkedItems.length,
    totalAmount: commerce.formatMoney(totalAmount)
  }
}
